import SimulatorConfiguration from "./SimulatorHelper";
import * as IdbKeyVal from "idb-keyval";

//ethernet address: 169.254.7.248
export const wiFiIpAddress = "172.30.20.1";

export const getWsUrl = (simulatorConfiguration: SimulatorConfiguration): string => {    
    let url = "";
    let ip = simulatorConfiguration.connectionType === "Ethernet" ? simulatorConfiguration.ethernetAddress : simulatorConfiguration.wifiAddress;
    if (ip !== "*test*") {
        url = `ws://${ip}/ws`;
    }
    return url;
}

export const saveConfiguration = async (simulatorConfiguration: SimulatorConfiguration) => {
    await IdbKeyVal.set('simulatorConfiguration', simulatorConfiguration);
}

export const getConfiguration = async () => {
    let simulatorConfiguration = new SimulatorConfiguration();
    const response = await IdbKeyVal.get<SimulatorConfiguration>('simulatorConfiguration');
    if (response) {
        simulatorConfiguration = response;
    }
    return simulatorConfiguration;
}
